export default [
    {
        path: '/task',
        name: 'tasks',
        component: () => import('@/views/task/TasksView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/task/:id',
        name: 'task',
        component: () => import('@/views/task/TaskView.vue'),
        meta: {
            requiresAuth: true
        },
    },
]
